<script lang="ts">
      import { untrack } from 'svelte'
      import BlockWidth from '../blocks/BlockWidth.svelte'
      import Carousel from './Carousel.svelte'
      import { setRollover } from '$lib/utils/array'

      function flattenBlock(block: any) {
            if (block.blockType == 'carouselImageVideoBlock') {
                  return block.media.map((m: any) => ({ ...m, blockType: block.blockType }))
            }
            return null
      }

      function flattenBlocks(blocks: any[]) {
            const _blocks = blocks.map(flattenBlock).filter((b: any) => b !== null)
            let flat: any[] = []

            for (let i = 0; i < _blocks.length; i++) {
                  flat = flat.concat(_blocks[i])
            }

            return flat
      }

      let { block } = $props()

      let _blocks: any[] = $state([])

      $effect(() => {
            block
            untrack(() => {
                  _blocks = flattenBlocks(block.content)
            })
      })
</script>

<BlockWidth width={block.width ?? 'normal'}>
      <Carousel blocks={_blocks} fixedAspect={block.fixedAspect} height={block.rowHeight ?? 'normal'}></Carousel>
</BlockWidth>

<style lang="postcss">
</style>
